import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import './styles/tokens.css'
import './styles/base.css'
import { router } from './router'
import { applyTheme, storedChoice } from './lib/theme'
import { AuthProvider, useAuth } from './lib/auth'
import { LoginPage } from './routes/Login'
import { MfaEinrichtungPage } from './routes/MfaEinrichtung'
import { KundenportalPage } from './routes/Kundenportal'

// Das Farbschema wird vor dem ersten Rendern gesetzt, damit die Oberfläche
// nicht kurz im falschen Modus aufblitzt.
applyTheme(storedChoice())

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: false,
    },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('Wurzelelement #root fehlt in index.html')

/**
 * Ohne Anmeldung gibt es nur die Anmeldeseite, ohne eingerichtete Zwei-Faktor-
 * Anmeldung nur deren Einrichtung. Die Oberfläche selbst wird erst aufgebaut,
 * wenn beides besteht – so kann keine Ansicht kurz aufblitzen, bevor der
 * Server sie ablehnt.
 */
function Root() {
  const { me, loading } = useAuth()
  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <span className="muted">Wird geladen …</span>
      </div>
    )
  }
  if (!me) return <LoginPage />
  if (!me.mfa_enabled) return <MfaEinrichtungPage />
  // Ein Konto des Kundenportals bekommt nur das Portal, nie die Anwendung
  // der Technik (Stufe 6.9).
  if (me.portal_customer_id) return <KundenportalPage />
  return <RouterProvider router={router} />
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Root />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
